module.exports = __webpack_public_path__ + "media/images/project/drag-light-708ad7735c4ee1ac291c3cea02cccc7e.svg";